var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedIllus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 480,
    height: 200,
    viewBox: "0 0 480 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 51.39,
    height: 62.273,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16795",
    "data-name": "Rectangle 16795",
    width: 51.39,
    height: 62.273,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fac91f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8a728"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verified-illus",
    transform: "translate(-252 -229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16794",
    "data-name": "Rectangle 16794",
    width: 480,
    height: 200,
    rx: 10,
    transform: "translate(252 229)",
    fill: "#fff",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M20.7,49.134.893,29.326a3.047,3.047,0,0,1,0-4.31l4.31-4.31a3.047,3.047,0,0,1,4.31,0L22.855,34.05,51.436,5.47a3.047,3.047,0,0,1,4.31,0l4.31,4.31a3.048,3.048,0,0,1,0,4.31L25.01,49.134A3.047,3.047,0,0,1,20.7,49.134Z",
    transform: "translate(462.101 305.05)",
    fill: "#f9b225"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(313.812 354.07) rotate(-30)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M114.023,280.845a2.036,2.036,0,0,1-1.782-1.029l-2.6-4.511a2.057,2.057,0,0,1,1.782-3.086h5.209a2.057,2.057,0,0,1,1.782,3.086l-2.6,4.511a2.036,2.036,0,0,1-1.782,1.029",
    transform: "translate(-88.309 -219.823)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M111.372,268.222a.806.806,0,0,1,.7,1.209l-2.6,4.511a.806.806,0,0,1-1.4,0l-2.6-4.511a.806.806,0,0,1,.7-1.209Zm0-2.5h-5.209a3.308,3.308,0,0,0-2.865,4.962l2.6,4.511a3.308,3.308,0,0,0,5.73,0l2.6-4.511a3.308,3.308,0,0,0-2.865-4.962",
    transform: "translate(-83.053 -214.575)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M76.757,165c-7.47,0-13.548-6.682-13.548-14.9s6.077-14.9,13.548-14.9S90.3,141.9,90.3,150.109,84.227,165,76.757,165",
    transform: "translate(-51.043 -109.188)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M85.6,139.91c-1.915-6.494-7.5-11.193-14.089-11.193s-12.172,4.7-14.088,11.193a17.432,17.432,0,0,0-.71,4.952q0,.875.085,1.727c.789,8.105,7.076,14.421,14.713,14.421s13.926-6.315,14.715-14.421q.084-.852.085-1.727a17.432,17.432,0,0,0-.71-4.952m-14.089,18.6c-5.468,0-10.115-3.982-11.707-9.472a15.1,15.1,0,0,1-.26-7.312c1.28-6.015,6.161-10.5,11.966-10.5S82.2,135.71,83.478,141.725a15.094,15.094,0,0,1-.26,7.31c-1.592,5.49-6.238,9.472-11.708,9.472",
    transform: "translate(-45.796 -103.942)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M86.309,191.819q0,.875-.085,1.727a18.637,18.637,0,0,1-3.007,2.446,21,21,0,0,1-11.708,3.293A20.987,20.987,0,0,1,59.8,195.992a18.552,18.552,0,0,1-3.007-2.446q-.084-.852-.085-1.727a17.432,17.432,0,0,1,.71-4.952,14.275,14.275,0,0,0,2.121,1.813c2.537,1.782,6.344,3.291,11.966,3.291s9.431-1.509,11.968-3.289a14.394,14.394,0,0,0,2.121-1.815,17.432,17.432,0,0,1,.71,4.952",
    transform: "translate(-45.796 -150.899)",
    fill: "#fac91f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M14.911,153.55c-3.374,0-6.2-1.5-7.563-4-2.265-4.17.131-9.865,5.341-12.7,4.481-2.434,7.855-3.617,10.317-3.617a3.674,3.674,0,0,1,3.6,1.9c1.065,1.96,1.051,5.454-.036,8.9-1.157,3.673-3.275,6.641-5.664,7.939a12.629,12.629,0,0,1-5.994,1.574",
    transform: "translate(-5.244 -107.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M17.762,126.735v2.5c1.6,0,2.148.6,2.5,1.246.9,1.651.844,4.837-.13,7.93-1.062,3.371-2.957,6.068-5.068,7.215a11.377,11.377,0,0,1-5.4,1.422A7.081,7.081,0,0,1,3.2,143.7a6.55,6.55,0,0,1-.118-5.667A10.854,10.854,0,0,1,8.042,132.7c4.233-2.3,7.5-3.466,9.72-3.466Zm0,0c-3.23,0-7.33,1.822-10.914,3.769C1.022,133.669-1.594,140.113,1,144.9c1.64,3.02,4.967,4.656,8.662,4.656a13.875,13.875,0,0,0,6.592-1.726c5.826-3.165,8.8-13.755,6.2-18.538a4.925,4.925,0,0,0-4.7-2.553",
    transform: "translate(0 -102.341)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M164.39,153.55a12.629,12.629,0,0,1-5.995-1.574c-2.39-1.3-4.507-4.266-5.664-7.939-1.087-3.448-1.1-6.943-.036-8.9a3.674,3.674,0,0,1,3.6-1.9c2.461,0,5.836,1.183,10.317,3.617,5.21,2.831,7.606,8.526,5.341,12.7-1.361,2.506-4.189,4-7.562,4Z",
    transform: "translate(-122.667 -107.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M151.021,129.237c2.216,0,5.486,1.166,9.719,3.466a10.854,10.854,0,0,1,4.957,5.332,6.55,6.55,0,0,1-.118,5.667,7.081,7.081,0,0,1-6.464,3.348,11.377,11.377,0,0,1-5.4-1.422c-2.111-1.147-4.006-3.845-5.068-7.215-.974-3.093-1.027-6.279-.13-7.93.351-.647.9-1.246,2.5-1.246m0-2.5a4.925,4.925,0,0,0-4.7,2.553c-2.6,4.783.376,15.373,6.2,18.538a13.874,13.874,0,0,0,6.592,1.726c3.7,0,7.022-1.636,8.662-4.656,2.6-4.783-.017-11.227-5.843-14.392-3.584-1.947-7.684-3.769-10.914-3.769",
    transform: "translate(-117.394 -102.341)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M75.228,27.735a15.108,15.108,0,0,0-9.886-11.754",
    transform: "translate(-52.765 -12.905)",
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M150.483,27.735a15.108,15.108,0,0,1,9.886-11.754",
    transform: "translate(-121.518 -12.905)",
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M52.509,9.235a1.368,1.368,0,1,1,1.368-1.368,1.369,1.369,0,0,1-1.368,1.368",
    transform: "translate(-41.297 -5.249)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M47.26,2.5a.116.116,0,1,1-.116.116A.116.116,0,0,1,47.26,2.5m0-2.5a2.619,2.619,0,1,0,2.619,2.619A2.619,2.619,0,0,0,47.26,0",
    transform: "translate(-36.049)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M203.2,9.235a1.368,1.368,0,1,1,1.368-1.368A1.369,1.369,0,0,1,203.2,9.235",
    transform: "translate(-162.988 -5.249)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M197.956,2.5a.116.116,0,1,1-.116.116.116.116,0,0,1,.116-.116m0-2.5a2.619,2.619,0,1,0,2.619,2.619A2.619,2.619,0,0,0,197.956,0",
    transform: "translate(-157.739)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M88.478,91.279c-5.93,0-10.754-3.861-10.754-8.606s4.824-8.606,10.754-8.606,10.754,3.86,10.754,8.606-4.824,8.606-10.754,8.606",
    transform: "translate(-62.764 -59.811)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M83.23,70.069a10.854,10.854,0,0,1,6.9,2.319,6.175,6.175,0,0,1,0,10.072,11.429,11.429,0,0,1-13.8,0,6.175,6.175,0,0,1,0-10.072,10.854,10.854,0,0,1,6.9-2.319m0-2.5c-6.63,0-12,4.413-12,9.857s5.375,9.857,12,9.857,12-4.413,12-9.857-5.375-9.857-12-9.857",
    transform: "translate(-57.516 -54.562)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8476",
    "data-name": "Group 8476",
    transform: "translate(642.316 380.745) rotate(-150)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M4.665,0A2.036,2.036,0,0,0,2.883,1.029L.279,5.54A2.057,2.057,0,0,0,2.06,8.626H7.269A2.057,2.057,0,0,0,9.051,5.54l-2.6-4.511A2.036,2.036,0,0,0,4.665,0",
    transform: "translate(21.049 1.251)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M8.522,8.625a.806.806,0,0,0,.7-1.209l-2.6-4.511a.806.806,0,0,0-1.4,0l-2.6,4.511a.806.806,0,0,0,.7,1.209Zm0,2.5H3.313A3.308,3.308,0,0,1,.448,6.165l2.6-4.511a3.308,3.308,0,0,1,5.73,0l2.6,4.511a3.308,3.308,0,0,1-2.865,4.962",
    transform: "translate(19.796 0)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M13.548,0C6.077,0,0,6.682,0,14.9s6.077,14.9,13.548,14.9S27.1,23.109,27.1,14.9,21.018,0,13.548,0",
    transform: "translate(12.166 6.456)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M28.887,21.1c-1.915,6.494-7.5,11.193-14.089,11.193S2.625,27.594.71,21.1A17.432,17.432,0,0,1,0,16.147q0-.875.085-1.727C.874,6.315,7.16,0,14.8,0S28.724,6.315,29.513,14.421q.084.852.085,1.727a17.432,17.432,0,0,1-.71,4.952M14.8,2.5C9.329,2.5,4.683,6.485,3.091,11.974a15.1,15.1,0,0,0-.26,7.312C4.111,25.3,8.993,29.79,14.8,29.79S25.486,25.3,26.766,19.284a15.094,15.094,0,0,0-.26-7.31C24.914,6.485,20.268,2.5,14.8,2.5",
    transform: "translate(10.916 5.206)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M29.6,7.466q0-.875-.085-1.727a18.637,18.637,0,0,0-3.007-2.446A21,21,0,0,0,14.8,0,20.987,20.987,0,0,0,3.091,3.293,18.552,18.552,0,0,0,.085,5.74Q0,6.591,0,7.466a17.432,17.432,0,0,0,.71,4.952,14.275,14.275,0,0,1,2.121-1.813C5.368,8.823,9.175,7.314,14.8,7.314S24.229,8.823,26.766,10.6a14.394,14.394,0,0,1,2.121,1.815,17.432,17.432,0,0,0,.71-4.952",
    transform: "translate(10.916 13.886)",
    fill: "#fac91f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M8.417,0C5.043,0,2.216,1.5.854,4-1.411,8.172.985,13.867,6.2,16.7c4.481,2.434,7.855,3.617,10.317,3.617a3.674,3.674,0,0,0,3.6-1.9c1.065-1.96,1.051-5.454-.036-8.9C18.919,5.84,16.8,2.872,14.412,1.574A12.629,12.629,0,0,0,8.417,0",
    transform: "translate(1.25 16.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M17.763,22.817v-2.5c1.6,0,2.148-.6,2.5-1.246.9-1.651.844-4.837-.13-7.93-1.062-3.371-2.957-6.068-5.068-7.215A11.377,11.377,0,0,0,9.667,2.5,7.081,7.081,0,0,0,3.2,5.85a6.55,6.55,0,0,0-.118,5.667,10.854,10.854,0,0,0,4.957,5.332c4.233,2.3,7.5,3.466,9.72,3.466Zm0,0c-3.23,0-7.33-1.822-10.914-3.769C1.022,15.883-1.594,9.439,1,4.656,2.645,1.636,5.971,0,9.667,0a13.875,13.875,0,0,1,6.592,1.726c5.826,3.165,8.8,13.755,6.2,18.538a4.925,4.925,0,0,1-4.7,2.553",
    transform: "translate(0 15.062)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M12.484,0A12.629,12.629,0,0,0,6.489,1.574C4.1,2.872,1.982,5.84.825,9.513c-1.087,3.448-1.1,6.943-.036,8.9a3.674,3.674,0,0,0,3.6,1.9c2.461,0,5.836-1.183,10.317-3.617,5.21-2.831,7.606-8.526,5.341-12.7C18.685,1.5,15.858,0,12.484,0Z",
    transform: "translate(29.239 16.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M5.646,20.315c2.216,0,5.486-1.166,9.719-3.466a10.854,10.854,0,0,0,4.957-5.332A6.55,6.55,0,0,0,20.2,5.85,7.081,7.081,0,0,0,13.741,2.5a11.377,11.377,0,0,0-5.4,1.422C6.232,5.071,4.337,7.769,3.275,11.14c-.974,3.093-1.027,6.279-.13,7.93.351.647.9,1.246,2.5,1.246m0,2.5a4.925,4.925,0,0,1-4.7-2.553c-2.6-4.783.376-15.373,6.2-18.538A13.874,13.874,0,0,1,13.741,0c3.7,0,7.022,1.636,8.662,4.656,2.6,4.783-.017,11.227-5.843,14.392C12.976,21,8.875,22.817,5.646,22.817",
    transform: "translate(27.982 15.062)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M9.886,0A15.108,15.108,0,0,1,0,11.754",
    transform: "translate(12.577 47.444)",
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M0,0A15.108,15.108,0,0,0,9.886,11.754",
    transform: "translate(28.965 47.444)",
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M1.368,0A1.368,1.368,0,1,0,2.735,1.368,1.369,1.369,0,0,0,1.368,0",
    transform: "translate(9.844 58.287)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M2.619,2.735A.116.116,0,1,0,2.5,2.619a.116.116,0,0,0,.116.116m0,2.5A2.619,2.619,0,1,1,5.237,2.619,2.619,2.619,0,0,1,2.619,5.237",
    transform: "translate(8.592 57.036)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M1.368,0A1.368,1.368,0,1,0,2.735,1.368,1.369,1.369,0,0,0,1.368,0",
    transform: "translate(38.849 58.287)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M2.619,2.735A.116.116,0,1,0,2.5,2.619a.116.116,0,0,0,.116.116m0,2.5A2.619,2.619,0,1,1,5.237,2.619,2.619,2.619,0,0,1,2.619,5.237",
    transform: "translate(37.598 57.036)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M10.754,0C4.824,0,0,3.861,0,8.606s4.824,8.606,10.754,8.606,10.754-3.86,10.754-8.606S16.683,0,10.754,0",
    transform: "translate(14.96 30.805)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M12,17.211a10.854,10.854,0,0,0,6.9-2.319,6.55,6.55,0,0,0,2.6-5.036,6.55,6.55,0,0,0-2.6-5.036A10.854,10.854,0,0,0,12,2.5,10.854,10.854,0,0,0,5.1,4.821,6.55,6.55,0,0,0,2.5,9.857a6.55,6.55,0,0,0,2.6,5.036A10.854,10.854,0,0,0,12,17.211m0,2.5c-6.63,0-12-4.413-12-9.857S5.375,0,12,0s12,4.413,12,9.857-5.375,9.857-12,9.857",
    transform: "translate(13.709 29.554)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 7.507,
    cy: 7.507,
    r: 7.507,
    transform: "translate(679.453 260.301)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1353",
    "data-name": "Ellipse 1353",
    cx: 8.507,
    cy: 8.507,
    r: 8.507,
    transform: "translate(281.453 361.173)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1354",
    "data-name": "Ellipse 1354",
    cx: 3.507,
    cy: 3.507,
    r: 3.507,
    transform: "translate(581.493 395.985)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1355",
    "data-name": "Ellipse 1355",
    cx: 5.507,
    cy: 5.507,
    r: 5.507,
    transform: "translate(330.493 248)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1352",
    "data-name": "Ellipse 1352",
    cx: 4.507,
    cy: 4.507,
    r: 4.507,
    transform: "translate(365.945 298.301)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(419.72 256.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M142.04,77.48a6.9,6.9,0,0,1-1.08-1.08,6.645,6.645,0,0,1,1.08-9.32,6.624,6.624,0,0,0-1.8-11.41,6.249,6.249,0,0,1-1.36-.7,6.625,6.625,0,0,1-1.85-9.19,6.656,6.656,0,0,0,1.1-3.4c0-.09.01-.18.01-.28a6.636,6.636,0,0,0-6.36-6.62,6.655,6.655,0,0,1-6.12-8.42,6.625,6.625,0,0,0-6.39-8.41,6.464,6.464,0,0,0-1.78.24,6.428,6.428,0,0,1-1.51.24c-.09,0-.18.01-.28.01a6.636,6.636,0,0,1-6.62-6.36,6.633,6.633,0,0,0-10.3-5.24,6.712,6.712,0,0,1-3.67,1.11,6.642,6.642,0,0,1-6.22-4.33A6.621,6.621,0,0,0,77.48,2.51,6.553,6.553,0,0,1,76.4,3.6a6.657,6.657,0,0,1-4.12,1.43,6.594,6.594,0,0,1-5.2-2.52A6.631,6.631,0,0,0,55.67,4.32a6.249,6.249,0,0,1-.7,1.36,6.625,6.625,0,0,1-9.19,1.85,6.656,6.656,0,0,0-3.4-1.1c-.09,0-.18-.01-.28-.01a6.636,6.636,0,0,0-6.62,6.36,6.655,6.655,0,0,1-8.42,6.12,6.625,6.625,0,0,0-8.41,6.39,6.464,6.464,0,0,0,.24,1.78,6.428,6.428,0,0,1,.24,1.51c0,.09.01.18.01.28a6.636,6.636,0,0,1-6.36,6.62,6.633,6.633,0,0,0-5.24,10.3,6.712,6.712,0,0,1,1.11,3.67,6.619,6.619,0,0,1-4.33,6.21,6.786,6.786,0,0,0-2.89,2.1,6.645,6.645,0,0,0,1.08,9.32A6.553,6.553,0,0,1,3.6,68.16a6.657,6.657,0,0,1,1.43,4.12,6.594,6.594,0,0,1-2.52,5.2A6.631,6.631,0,0,0,4.32,88.89a6.25,6.25,0,0,1,1.36.7,6.625,6.625,0,0,1,1.85,9.19,6.656,6.656,0,0,0-1.1,3.4c0,.09-.01.18-.01.28a6.636,6.636,0,0,0,6.36,6.62,6.655,6.655,0,0,1,6.12,8.42,6.625,6.625,0,0,0,6.39,8.41,6.464,6.464,0,0,0,1.78-.24,6.428,6.428,0,0,1,1.51-.24c.09,0,.18-.01.28-.01a6.636,6.636,0,0,1,6.62,6.36,6.633,6.633,0,0,0,10.3,5.24,6.712,6.712,0,0,1,3.67-1.11,6.619,6.619,0,0,1,6.21,4.33,6.786,6.786,0,0,0,2.1,2.89,6.636,6.636,0,0,0,9.32-1.09,6.9,6.9,0,0,1,1.08-1.08,6.645,6.645,0,0,1,9.32,1.08,6.624,6.624,0,0,0,11.41-1.8,6.25,6.25,0,0,1,.7-1.36,6.625,6.625,0,0,1,9.19-1.85,6.656,6.656,0,0,0,3.4,1.1c.09,0,.18.01.28.01a6.636,6.636,0,0,0,6.62-6.36,6.428,6.428,0,0,1,.24-1.51,6.634,6.634,0,0,1,6.38-4.85,6.551,6.551,0,0,1,1.79.25,6.758,6.758,0,0,0,3.57,0,6.634,6.634,0,0,0,4.85-6.39,6.414,6.414,0,0,0-.24-1.78,6.511,6.511,0,0,1-.24-1.51c0-.1-.01-.2-.01-.29a6.65,6.65,0,0,1,6.36-6.62,6.633,6.633,0,0,0,5.24-10.3,6.712,6.712,0,0,1-1.11-3.67,6.619,6.619,0,0,1,4.33-6.21,6.786,6.786,0,0,0,2.89-2.1,6.636,6.636,0,0,0-1.09-9.32ZM72.28,120.59a48.31,48.31,0,1,1,48.31-48.31,48.311,48.311,0,0,1-48.31,48.31Z",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIllus);
export default __webpack_public_path__ + "static/media/verified-illus.1310af8a3e48e522c263bf57d075a925.svg";
export { ForwardRef as ReactComponent };